import React, { useEffect, useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import AppStoreBadge, {
  ANDROID_STORE_URL,
  IOS_STORE_URL,
} from './AppStoreBadge';
import qrCode from 'qrcode';

const STORE_BADGE_WIDTH = 185;

type Props = {
  className?: string;
};

export default function DownloadSection({ className }: Props) {
  const qrIosCanvasRef = useRef(null);
  const qrAndroidCanvasRef = useRef(null);

  useEffect(() => {
    qrCode.toCanvas(qrIosCanvasRef.current, IOS_STORE_URL, {
      width: 200,
      margin: 0,
    });
    qrCode.toCanvas(qrAndroidCanvasRef.current, ANDROID_STORE_URL, {
      width: 200,
      margin: 0,
    });
  }, []);

  return (
    <section
      className={twMerge(
        'relative py-20 mt-20 mb-64 border-t border-lightGray',
        className,
      )}
      id={'download'}
    >
      <div className="sm:w-3/4 lg:w-5/6 mx-auto">
        <h1 className="text-center">Get Started</h1>
        <h3 className="mt-8 text-center">
          Download the TopHouse app to browse live property listings
        </h3>
        <div
          className={
            'flex flex-col md:flex-row gap-y-8 gap-x-48 mt-12 align-center md:justify-center'
          }
        >
          <div className={'flex flex-col items-center'}>
            <AppStoreBadge
              platform={'ios'}
              target={'_blank'}
              width={STORE_BADGE_WIDTH}
            />
            <canvas ref={qrIosCanvasRef} className={'hidden md:flex mt-8'} />
          </div>
          <div className={'flex flex-col items-center'}>
            <AppStoreBadge
              platform={'android'}
              target={'_blank'}
              width={STORE_BADGE_WIDTH}
            />
            <canvas
              ref={qrAndroidCanvasRef}
              className={'hidden md:flex mt-8'}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
